// ─── SettingsPage.jsx ───────────────────────────────────────────────────────
import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, CardContent, TextField, Button, Grid, CircularProgress, Divider, Alert } from '@mui/material';
import { Save } from '@mui/icons-material';
import { notificationsAPI } from '../services/api';
import { toast } from 'react-toastify';

export const SettingsPage = () => {
  const [settings, setSettings] = useState([]); const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false); const [values, setValues] = useState({});
  useEffect(() => {
    notificationsAPI.getSettings().then(r => {
      setSettings(r.data.data||[]);
      const v = {}; (r.data.data||[]).forEach(s => { v[s.key] = s.value; }); setValues(v);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);
  const handleSave = async () => {
    try { setSaving(true);
      await notificationsAPI.updateSettings({ settings: Object.entries(values).map(([key, value]) => ({ key, value })) });
      toast.success('Settings saved');
    } catch { toast.error('Failed to save settings'); } finally { setSaving(false); }
  };
  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}><CircularProgress /></Box>;
  const groups = [...new Set(settings.map(s => s.category))];
  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h4" fontWeight={700}>System Settings</Typography>
        <Button variant="contained" startIcon={<Save />} onClick={handleSave} disabled={saving}>{saving ? 'Saving...' : 'Save All'}</Button>
      </Box>
      {groups.map(group => (
        <Card key={group} sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h6" fontWeight={700} sx={{ mb: 2, textTransform: 'capitalize' }}>{group} Settings</Typography>
            <Grid container spacing={2}>
              {settings.filter(s => s.category === group).map(setting => (
                <Grid item xs={12} sm={6} key={setting.key}>
                  <TextField fullWidth label={setting.description || setting.key} size="small"
                    value={values[setting.key] || ''} onChange={(e) => setValues({ ...values, [setting.key]: e.target.value })}
                    helperText={`Key: ${setting.key}`} />
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};
export default SettingsPage;
